import { afterNextRender, Component, computed, inject, signal } from '@angular/core';
import { Product } from '../../../product/product.types';
import { ResolutionService } from '../../../shared/resolution.service';
import { FavOrDislike } from '../../../shared/product-card/product-card.types';
import { ProductCardV2Component } from '../../../shared/product-card-v2/product-card-v2.component';
import { ProductsService } from '../../../product/products.service';
import { tap } from 'rxjs';
import { Router } from '@angular/router';

@Component({
  selector: 'app-preferences-signup',
  imports: [
    ProductCardV2Component
  ],
  templateUrl: './preferences-signup.component.html',
  styleUrl: './preferences-signup.component.scss'
})
export class PreferencesSignupComponent {

  //#region Services

  #resolutionService = inject(ResolutionService);

  #productsService = inject(ProductsService);

  #router = inject(Router);

  //#endregion

  //#region Inputs / Outputs

  subscriptionCard = signal<Product[]>([]);

  canContinue = signal(false);

  //#endregion

  //#region Properties

  isMobile = computed(() => this.#resolutionService.isMobile());

  //#endregion

  //#region Constructor

  constructor() {
    afterNextRender(() => this.#getSignupProducts());
  }

  //#endregion

  //#region Methods

  clickFavOrDisliked(event: FavOrDislike) {

    this.canContinue.set(true);

    if (!event.isDisliked) return;

    const index = this.subscriptionCard().findIndex(x => x.id === event.id);

    if (index === -1)
      return;

    const product = this.subscriptionCard().splice(index, 1);
    this.subscriptionCard().push(product[0]);
  }

  #getSignupProducts() {
    this.#productsService
      .getSignupProducts()
      .pipe(
        tap(response => {

          if (!response.data || !response.data?.length)
            return;

          this.subscriptionCard
            .set(response.data);

          this.canContinue
            .set(response.data.some(x => x.fav || x.disliked));
        })
      ).subscribe();
  }

  continue() {
    this.#router.navigate(['/shop']);
  }

  //#endregion
}
